module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile@2x-f5e401e05316c01f190996cb0fa8e499.jpg";